import Typography from "@mui/material/Typography";

import { Location } from "../../interfaces";

interface IProps {
  location: Location;
}

export const LocationInfo = ({ location }: IProps) => {
  return (
    <Typography
      variant="h5"
      sx={{ fontWeight: "600", color: "#373737", textAlign: "center" }}
    >
      {location?.address}
    </Typography>
  );
};
